import axios from 'axios'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../../config/api'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import { ProductAdmin } from '../../../interfaces/Producto/ProductAdmin'
import { templateExternalStorageSkuMassive, templateMassiveVasRuleList } from '../../../const/templatesFileName'


export const getSkuList = (
  filters: Filter[],
  page: number,
  pageSize: number,
  orderBy?: GenericOrderBy<ProductAdmin>
) => {
  const url = new URL(`${ApiConfig.StockKeepingUnitAdminApi}`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const getVasRuleAssignable = (
  skuId: number,
  page: number,
  pageSize: number,
  name?: string
) => {
  const url = new URL(`${ApiConfig.VasRuleApi}/sku/${skuId}/assignable`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (name) url.searchParams.set('name', name)

  return axios.get(url.toString())
}

export const getVasRuleAvailable = (
  skuId: number,
  page: number,
  pageSize: number,
  name?: string
) => {
  const url = new URL(`${ApiConfig.VasRuleApi}/sku/${skuId}/available`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (name) url.searchParams.set('name', name)

  return axios.get(url.toString())
}

export const vasRuleAssignToSku = (id: number, skuId: number) => {
  const url = new URL(`${ApiConfig.VasRuleApi}/${id}/sku/${skuId}`)

  return axios.put(url.toString())
}

export const vasRuleUnassignToSku = (id: number, skuId: number) => {
  const url = new URL(`${ApiConfig.VasRuleApi}/${id}/sku/${skuId}`)

  return axios.delete(url.toString())
}

// TODO: Reemplazar con el endpoint real cuando esté disponible
export const postVasRuleMassive = (formData: FormData) => {
  const url = new URL(`${ApiConfig.ProcessApi}/CreateVasRuleMasive`)

  return axios.post(url.toString(), formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const getVasRuleList = (
  filters: Filter[],
  page: number,
  pageSize: number
) => {
  const url = new URL(`${ApiConfig.VasRuleApi}`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  return axios.get(url.toString())
}

export const getVasRuleByBrand = (
  productOriginId: number,
  page: number,
  pageSize: number
) => {
  const url = new URL(`${ApiConfig.VasRuleApi}/brand/${productOriginId}/available`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())


  return axios.get(url.toString())
}

export const getVasRuleTemplate = () => {
  const url = new URL(
    `${ApiConfig.ProcessApi}/GetTemplateFile/${templateMassiveVasRuleList}`
  )
  return axios.get(url.toString())
}


export const postExternalStorageMassive = (formData: FormData) => {
  const url = new URL(`${ApiConfig.ProcessApi}/ExternalStorageMassive`)

  return axios.post(url.toString(), formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const getExternalStorageSkuMasiveTemplate = () => {
  const url = new URL(
    `${ApiConfig.ProcessApi}/GetTemplateFile/${templateExternalStorageSkuMassive}`
  )
  return axios.get(url.toString())
}

export const postExternalStorage = (skid: number, externalStorage: boolean) => {
  const url = new URL(
    `${ApiConfig.StockKeepingUnitApi}/ExternalStorage/${skid}`
  )
  return axios.patch(url.toString(), JSON.stringify(externalStorage), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}